import axios from 'axios';
import { toFromDates, grabMonthsToAndFromDates } from '../components/Common/cleanDates';

import {
  REQUEST_SALES_PERFORMANCE_BY_FILTER,
  REQUEST_SALES_PERFORMANCE_SUCCESS,
  REQUEST_SALES_PERFORMANCE_FAILURE,
  REQUEST_USER_PERFORMANCE_BY_FILTER,
  REQUEST_USER_PERFORMANCE_SUCCESS,
  REQUEST_USER_PERFORMANCE_FAILURE,
  RESET_CURRENT_BIN,
  FETCH_STORES_SUCCESS,
  FETCHING_STORES,
} from './type';

import {
  SALES_PERFORMANCE_URL,
  USER_PERFORMANCE_URL,
} from './url';

import {
  ROOT_URL, ROOT_API_URL, companyCodeTitle, isDAICHEONG, isOCM, isGGI, isOLG,
  isABBLE, isGFD
} from '../actions/root_url';

const isAFM =
  ROOT_API_URL === "https://afm-scm.truckxi.com/api/" ||
  ROOT_URL === "https://afm-scm.truckxi.com/api/" ||
  ROOT_API_URL === "https://afmstage-scm.truckxi.com/api/" ||
  ROOT_URL === "https://afmstage-scm.truckxi.com/api/";

export function fetchSalesPerformanceByFilter(orderType, salesType, days, fromDate, toDate, type, productNum, group, category, aggregate, user, customer, store, department) {
  const dates = toFromDates(days, fromDate, toDate);
  if (salesType === 'salesorder') {
    fromDate = `SalesInvoice_id__DispatchDate__gte=${dates.fromDate}`;
    toDate = `SalesInvoice_id__DispatchDate__lte=${dates.toDate}`;
  } else if (salesType === 'posorder') {
    fromDate = `Order_id__Date__gte=${dates.fromDate}`;
    toDate = `Order_id__Date__lte=${dates.toDate}`;
  } else if (salesType === 'all') {
    fromDate = `date__gte=${dates.fromDate}`;
    toDate = `date__lte=${dates.toDate}`;
  } else {
    fromDate = `date__gte=${dates.fromDate}`;
    toDate = `date__lte=${dates.toDate}`;
  }
  let storeValue = '';
  if (store) {
    storeValue = `&store=${JSON.parse(store).join(',')}`
  }
  if (productNum) {
    productNum = `&Product_id__ProductNum=${productNum}`;
    group = '';
    category = '';
    department = '';
    aggregate = '';
    if (isDAICHEONG || isGGI || isOLG) {
      if (user) {
        user = `&Sales_User_id=${user}`;
      } else {
        user = '';
      }
      if (customer) {
        customer = `&SalesInvoice_id__Deliver_Customer_id=${customer}`;
      } else {
        customer = '';
      }
    } else {
      user = '';
      customer= '';
    }
  } else {
    productNum = '';
    if (group) {
      group = `&Product_id__ProductGroup_id=${group}`;
    } else {
      group = '';
    }
    if (category) {
      category = `&Product_id__ProductCategory1_id=${category}`;
    } else {
      category = '';
    }
    if (department) {
      department = `&Product_id__ProductDepartment_id=${department}`;
    } else {
      department = '';
    }
    if (aggregate) {
      aggregate = `&Aggregate=${aggregate}`;
    } else {
      aggregate = '';
    }
    if (user) {
      user = `&Sales_User_id=${user}`;
    } else {
      user = '';
    }
    if (customer) {
      customer = `&SalesInvoice_id__Deliver_Customer_id=${customer}`;
    } else {
      customer = '';
    }
  }
  let belongWarehouse = ``;
  if (!localStorage.getItem('warehouseLocation') || localStorage.getItem('warehouseLocation') === '') {
    belongWarehouse = ``;
  } else {
    belongWarehouse = `&BelongWarehouse=${localStorage.getItem('warehouseLocation')}`;
  }
  if (isAFM && orderType) {
    // orderType = `&order_type=${orderType}`;
    orderType = ``;
  } else {
    orderType = ``;
  }
  return (dispatch, getState) => {
    const state = getState();
    const Company_id = state.header.selectedCompany ? state.header.selectedCompany.value : null;
    const warehouse_id = state.header.selectedWarehouse ? state.header.selectedWarehouse.value : null;
    if (!Company_id) return;
    dispatch({
      type: REQUEST_SALES_PERFORMANCE_BY_FILTER,
      payload: {
        type,
        salesType,
        fromDate,
        toDate,
        productNum,
        group,
        department,
        category,
        aggregate,
        user,
        belongWarehouse,
        customer,
        orderType,
        Company_id,
        store: storeValue,
        warehouse_id,
      },
    });
  };
}

export const SalesPerformanceListEpic = action$ =>
  action$.ofType(REQUEST_SALES_PERFORMANCE_BY_FILTER)
    .switchMap(action => {
      let salesType = action.payload.salesType;
      if(isGFD && action.payload.salesType==='externalso') {
        salesType = 'all'
      }
      let url = `${SALES_PERFORMANCE_URL + action.payload.type}/${salesType}/?${action.payload.fromDate
      }&${action.payload.toDate}${action.payload.productNum}${action.payload.group}${action.payload.department}${action.payload.category
      }${action.payload.aggregate}${action.payload.user}${action.payload.belongWarehouse}${action.payload.orderType}${action.payload.customer}&Company_id=${action.payload.Company_id}${action.payload.store}`;
      if((isOCM || isGGI || isABBLE) && action.payload.warehouse_id && action.payload.warehouse_id != 0) {
        url = url + `&Pickup_Warehouse_id_id=${action.payload.warehouse_id}`;
      }
      if(isGFD && action.payload.salesType==='externalso') {
        url = url + `&exclude_internal=True`;
      }
      
      return axios.get(
        url,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        },
      )
    })
    .map(response => ({ type: REQUEST_SALES_PERFORMANCE_SUCCESS, payload: response }))
    .catch((err, source) => {
      return source;
    });
    // .catch(err => ({ type: REQUEST_SALES_PERFORMANCE_FAILURE, payload: err }));


export function fetchUserPerformanceByFilter(fromDate, toDate, userId, mode, days, lastMonth) {
  let dates;
  if ((days !== -1 || days !== '-1') && !lastMonth) {
    dates = grabMonthsToAndFromDates(days, fromDate, toDate, false);
  } else if ((days !== -1 || days !== '-1') && lastMonth) {
    dates = grabMonthsToAndFromDates(days, fromDate, toDate, lastMonth);
  } else {
    dates = toFromDates(days, fromDate, toDate);
  }
  return (dispatch) => {
    dispatch(requestUserPerformanceByFilter());
    return axios.get(`${USER_PERFORMANCE_URL}`, {
      params: {
        startDate: dates.fromDate,
        endDate: dates.toDate,
        userId,
        mode,
      },
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    })
      .then((response) => {
        dispatch(requestUserPerformanceSuccess(response.data));
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(requestUserPerformanceFailure(err));                       
        }
      });
  };
}

export const fetchStores = () => dispatch => {
  dispatch({
    type: FETCHING_STORES,
  })
  axios.get(`${ROOT_URL}v1/sale/get_store_name`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  })
    .then((response) => {
      dispatch({
        type: FETCH_STORES_SUCCESS,
        payload: response.data,
      })
    }, (err) => {
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
        dispatch({
          type: FETCH_STORES_SUCCESS,
          payload: [],
        })                     
      }
    });
}

export function requestUserPerformanceByFilter() {
  return {
    type: REQUEST_USER_PERFORMANCE_BY_FILTER,
  };
}

export function requestUserPerformanceSuccess(response) {
  return {
    type: REQUEST_USER_PERFORMANCE_SUCCESS,
    payload: response,
  };
}

export function requestUserPerformanceFailure(error) {
  return {
    type: REQUEST_USER_PERFORMANCE_FAILURE,
    payload: error,
  };
}



// WEBPACK FOOTER //
// ./master/jsx/actions/salesPerformanceList_actions.js